import styled from '@emotion/styled';
import aboutPic from '../assets/profile.png';
import cvPdf from '../assets/Lukas_Sivak_CV_30.November.25.pdf'; 
const AboutSection = styled.section`
  background: ${({ theme }) => theme.background};
  color: ${({ theme }) => theme.text};
  padding: 5.5rem 1.6rem 5.3rem;
`;

const SectionIntro = styled.p`
  font-size: 0.9rem;
  color: ${({ theme }) => theme.textSecondary || theme.text};
  margin-bottom: 0.35rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  margin-bottom: 2.2rem;
  letter-spacing: -0.03em;
`;

const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 3rem;
  max-width: 1000px;
  margin: 0 auto;
  margin-top: 1rem;

  @media(min-width: 768px) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
`;

const AboutImage = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;

  img {
    width: 250px;
    height: 250px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid ${({ theme }) => theme.line || '#e0e0e0'};
  }
`;

const AboutContent = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
  gap: 1.8rem;
`;

/* === New: CV Buttons === */
const CVActions = styled.div`
  display: flex;
  gap: 0.8rem;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 0.5rem;
`;

const Button = styled.a`
  display: inline-block;
  padding: 0.75rem 1.1rem;
  border-radius: 0;
  text-decoration: none;
  font-weight: 600;
  border: 1px solid ${({ theme }) => theme.line || '#ccc'};
  background: transparent;
  color: ${({ theme }) => theme.text};
  letter-spacing: 0.02em;
  transition: transform 0.2s ease, border-color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: ${({ theme }) => theme.accent || '#c8102e'};
  }
`;

const Divider = styled.hr`
  margin: 4rem auto 0;
  width: 60%;
  border: none;
  border-top: 1px solid ${({ theme }) => theme.textSecondary || '#ddd'};
`;

const Bio = styled.div`
  display: grid;
  gap: 1rem;
  font-size: 1.02rem;
  line-height: 1.7;
  color: ${({ theme }) => theme.text};
  text-align: left;
  margin: 0 auto;
  max-width: 520px;
`;

const Highlights = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  gap: 0.9rem;

  li {
    line-height: 1.6;
  }

  strong {
    display: inline-block;
    min-width: 10ch;
    letter-spacing: 0.02em;
  }
`;

const TechStackTitle = styled.h3`
  font-size: 1rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  margin: 0.2rem 0 0.1rem;
`;

const TechStackList = styled.p`
  margin: 0;
  line-height: 1.7;
`;

function About() {
  // const theme = useTheme();

  return (
    <AboutSection id="about">
      <SectionIntro>Junior Developer - Front-End Focus | Learning Backend</SectionIntro>
      <Title>About Me</Title>
      <AboutContainer>
        <AboutImage>
          <img src={aboutPic} alt="Portrait of Lukas Sivak" />
        </AboutImage>
        <AboutContent>
          <Bio>
            <Highlights>
              <li>
                <strong>Focus</strong> Clean UI, React, Emotion, and responsive layout systems. State management, data handling, and building UI around structured datasets. Currently expanding into backend fundamentals — Node.js, APIs, and system communication patterns.
              </li>
              <li>
                <strong>Flagship</strong> Qatar Airways–inspired airline dashboard with modular architecture, rotating mock datasets, responsive grid, and Emotion theming. Built with real architectural patterns: modular components, state containers, API-style data flow, and rotating mock datasets simulating backend responses.
              </li>
              <li>
                <strong>Clients</strong> Portfolio sites for a film composer and classical guitar teacher, designed and built end-to-end with responsive layouts and multimedia embeds.
              </li>
              <li>
                <strong>Approach</strong> Clarity first. Accessibility always. Calm design, disciplined typography, and small, thoughtful motion.
              </li>
            </Highlights>
            <div>
              <TechStackTitle>Tech Stack</TechStackTitle>
              <TechStackList>
                React, JavaScript (ES6+), HTML, CSS, Emotion, Redux, Vite, REST APIs, Node.js (basic), Git/GitHub, Responsive Design, Accessibility, UI Architecture.
              </TechStackList>
            </div>
            {/* CV Buttons */}
            <CVActions aria-label="CV actions">
              {/* Download the actual PDF from your repo */}
              <Button href={cvPdf} download>
                 Download CV
              </Button>

              {/* Mailto shortcut for recruiters */}
              <Button href="mailto:sivaklukas@yahoo.com?subject=Interview%20for%20Frontend%20Role%20(Lukas%20Sivak)">
                 Email Me
              </Button>
            </CVActions>
          </Bio>
        </AboutContent>
      </AboutContainer>
      <Divider />
    </AboutSection>
  );
}

export default About;
